  /*
  export function textTableToJSON(inputText) {
  const lines = inputText
    .trim()
    .split("\n")
    .map(line => line.trim())
    .filter(Boolean);

  if (lines.length < 2) return [];

  // Split headers and rows by tabs or 2+ spaces
  const splitRow = row => row.split(/\t+|\s{2,}/).map(v => v.trim());

  const headers = splitRow(lines[0]);
  const dataRows = lines.slice(1);

  return dataRows.map(row => {
    const values = splitRow(row);
    const obj = {};
    headers.forEach((key, index) => {
      obj[key] = values[index] || null;
    });
    return obj;
  });
}

  useEffect(() => {

    var inputText1 = ``;
    var result = textTableToJSON(inputText1);
    console.log(result);

  },[]);*/

import React, { useState } from "react";
import SiteRosterMatrix from "./SiteRosterMatrix";
import GlobalFatigueView from "./GlobalFatigueView";
import "./Sites.css";
import { useEffect } from "react";

export default function OpsDashboard({
  site,
  filters,
  global,
  onBack
}) {
  const [tab, setTab] = useState(global ? "FATIGUE" : "ROSTER");

  useEffect( () => {
    console.log("site -- ", site, filters, global);
  }, []);

  return (
    <div className="page">
      <div className="ops-header">
        <button onClick={onBack}>← Back</button>

        <h1>
          {global
            ? "🌍 Global Fatigue"
            : `📊 ${site.name}`}
        </h1>
        
        {site.manager_name && (
           <h3> Manager: {site.manager_name}</h3> )}
        
        <div className="context">
          📅 {filters.startMonth} → {filters.endMonth}
        </div>
      </div>

      {!global && (
        <div className="tabs">
          <button
            className={tab === "ROSTER" ? "active" : ""}
            onClick={() => setTab("ROSTER")}
          >
            Roster
          </button>

          <button
            className={tab === "FATIGUE" ? "active" : ""}
            onClick={() => setTab("FATIGUE")}
          >
            Fatigue
          </button>
        </div>
      )}

      {!global && tab === "ROSTER" && (
        <SiteRosterMatrix
          site={site}
          filters={filters}
        />
      )}

      {(global || tab === "FATIGUE") && (
        <GlobalFatigueView
          selectedSiteId={site?.siteId}
          filters={filters}
          global={global}
        />
      )}
    </div>
  );
}
